<template>
 <div class="home min-container">
    <div class="container">
      <div class="left">
        <p class="p1">
          ERROR 404
        </p>
        <p class="p2">
          Sorry, but the page that you requested does not exist
        </p>
        <div
          class="button1"
          @click="toHome()"
        >
          <p>Return to shop</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  data () {
    return {
    }
  },
  methods: {
    toHome () {
      this.$router.push({ name: 'home' })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.home {
  position: relative;
  width: 100%;
  height: 770px;
  background-image: url(/pc/static/img/hom/404_bg.jpg);
  background-size: auto 100%;
  background-repeat: no-repeat;
  background-position: center top;
  overflow: hidden;
  .container {
    position: relative;
    height: 100%;
  }
  .left {
    position: relative;
    width: 550px;
    padding-top: 250px;
    .p1 {
      font-size: 100px;
      line-height: 100px;
      font-weight: 700;
      margin-left: -10px;
      color: #ffffff;
    }
    .p2 {
      font-size: 16px;
      margin-top: 10px;
      margin-bottom: 60px;
      color: #ffdf00;
    }
    .button1 {
      width: 300px;
      height: 88px;
      background-image: url(/pc/static/img/hom/404_button.png);
      background-size: 100% auto;
      background-repeat: no-repeat;
      text-align: center;
      cursor: pointer;
      margin-bottom: 6px;
      margin-left: -20px;
      p {
        line-height: 50px;
        font-size: 24px;
        font-weight: 700;
        color: #4f0703;
      }
    }
  }
}
</style>
